'use strict';
var React = require('react');

var CommentTool = require('./Review/CommentTool.jsx');
var FullPage = require('./Page/FullPage');
var ErrorMessage = require('./ErrorMessage');

var PagePaint = React.createClass({
  propTypes: {
    background: React.PropTypes.string.isRequired,
    domSize: React.PropTypes.object.isRequired,
    meta: React.PropTypes.object.isRequired,
    page: React.PropTypes.object.isRequired,
    syncID: React.PropTypes.string.isRequired,
    syncVersion: React.PropTypes.string.isRequired,
    pageName: React.PropTypes.string.isRequired,
    review: React.PropTypes.array,
    onExitPaint: React.PropTypes.func.isRequired,
    sign: React.PropTypes.func.isRequired,
    isSign: React.PropTypes.bool.isRequired,
    onLoadReviewData: React.PropTypes.func.isRequired,
    onAddReview: React.PropTypes.func.isRequired,
    onUpdateReview: React.PropTypes.func.isRequired,
    onRemoveReview: React.PropTypes.func.isRequired,
    error: React.PropTypes.string,
    onClearError: React.PropTypes.func.isRequired,
    onError: React.PropTypes.func.isRequired,
  },
  getInitialState: function () {
    return {
      fullPageLocation: null,
      scrollLeft: 0
    };
  },
  render: function () {
    var page = this.props.page;
    var pageWidth = parseInt(page.measureW, 10);
    var pageHeight = parseInt(page.measureH, 10);
    var domSize = this.props.domSize;
    return (
      <div className="paint" style={{
        background: this.props.background
      }}>
        <ErrorMessage error={this.props.error}
                      onClearError={this.myOnClearError}
        />
        <div className="paint-wrapper" onScroll={this.scroll}>
          <CommentTool
            page={page}
            onToggleCommentMode={this.props.onToggleCommentMode}
            deviceScrollStyle={{
              width: Math.max(domSize.width, parseInt(page.measureW, 10)),
              height: pageHeight + 80 + 30
            }}
            scrollLeft={this.state.scrollLeft}
            review={this.props.review}
            onExitPaint={this.props.onExitPaint}
            onAddReview={this.onAddReview}
            onUpdateReview={this.onUpdateReview}
            onRemoveReview={this.onRemoveReview}
            fullPageLocation={this.state.fullPageLocation}
            sign={this.props.sign}
            isSign={this.props.isSign}
            onError={this.myOnError}
            onClearError={this.props.onClearError}
            syncID={this.props.syncID}
            syncVersion={this.props.syncVersion}
            ID={this.props.page.ID}
          />
          <FullPage
            page={page}
            pageDidLoad={this.pageDidLoad}
            fullPageLocation={this.state.fullPageLocation}
          />
        </div>
      </div>
    );
  },
  scroll: function(e) {
    this.setState({scrollLeft: e.target.scrollLeft});
  },
  componentDidMount: function () {
    this.props.onLoadReviewData(this.props.syncID, this.props.syncVersion, this.props.page.ID);
    var self = this;
  },
  componentWillUnmount: function() {
    window.onScroll = null;
  },
  pageDidLoad: function (location) {
    this.setState({fullPageLocation: location});
  },
  onAddReview: function (layer) {
    this.props.onAddReview(this.props.syncID, this.props.syncVersion, this.props.page.ID, this.props.pageName, layer.data.author, JSON.stringify(layer));
  },
  onUpdateReview: function (id, author, data) {
    this.props.onUpdateReview(this.props.syncID, this.props.syncVersion, this.props.page.ID, author, id, JSON.stringify(data));
  },
  onRemoveReview: function (author, id) {
    this.props.onRemoveReview(this.props.syncID, this.props.syncVersion, this.props.page.ID, author, id);
  },
  myOnClearError: null,
  myOnError: function(error, myOnClearError) {
    if(myOnClearError) {
      this.myOnClearError = myOnClearError;
    } else {
      this.myOnClearError = this.props.onClearError;
    }
    this.props.onError(error);
  }
});

module.exports = PagePaint;


// WEBPACK FOOTER //
// ./src/views/PagePaint.jsx